import { useMutation } from '@apollo/client';

import { UpdateInvoicePaymentMethodMutationDocument } from './graphql/updateInvoicePaymentMethod.gql';

interface UseUpdateInvoicePaymentMethodProps {
  invoiceId: string;
  allowCreditCardPayment: boolean;
}

export const useUpdateInvoicePaymentMethods = ({
  allowCreditCardPayment,
  invoiceId,
}: UseUpdateInvoicePaymentMethodProps) => {
  const [updateInvoicePaymentMethods, { loading }] = useMutation(
    UpdateInvoicePaymentMethodMutationDocument,
    {
      variables: {
        input: {
          allowCreditCardPayment,
          invoiceId,
        },
      },
    },
  );

  return {
    loading,
    updateInvoicePaymentMethods,
  };
};
